import React from 'react'
import { Link } from 'react-router-dom'
import { RsIcon } from '../icons'
import { usePortalFeatureLock } from '../../hooks/usePortalFeatureLock'

export default function FeatureAccessGate({ children }) {
  const { locked } = usePortalFeatureLock()

  if (!locked) return children

  return (
    <div className="portal-feature-gate">
      <div className="portal-feature-gate-content" aria-hidden="true">
        {children}
      </div>
      <div className="portal-feature-gate-overlay" role="dialog" aria-modal="true" aria-labelledby="portal-feature-gate-title">
        <div className="portal-feature-gate-card">
          <div className="portal-feature-gate-icon"><RsIcon name="lock" size="xl" /></div>
          <h2 id="portal-feature-gate-title">Upgrade Required</h2>
          <p className="portal-feature-gate-msg-en">
            You are currently not a paid user and cannot perform this operation. Please click &quot;Upgrade Plan&quot; to view the upgrade options.
          </p>
          <Link to="/payment" className="portal-feature-gate-btn primary">
            Upgrade Plan
          </Link>
        </div>
      </div>
    </div>
  )
}
